import api from './client';

export const getBreakers = (projectId, switchboardId) => api.get('/breakers', {
  params: { project: projectId, ...(switchboardId ? { switchboard: switchboardId } : {}) }
});
export const createBreaker = (data) => api.post('/breakers', data);
export const updateBreaker = (id, data) => api.put(`/breakers/${id}`, data);
export const deleteBreaker = (id) => api.delete(`/breakers/${id}`);
